export const HIRING_STEPS = [
  {
    icon: 'equifax-pointer-check',
    text: 'Selecione o plano'
  },
  {
    icon: 'equifax-file-export',
    text: 'Envie seus dados corretamente'
  },
  {
    icon: 'equifax-letter',
    text: 'Ative seu acesso e defina sua senha'
  },
  {
    icon: 'equifax-portal',
    text: 'Portal disponível para consultas'
  },
  {
    icon: 'equifax-bill',
    text: 'Receba e pague seu boleto'
  }
]
